import React from 'react';

export const BoardSelectionOverlay = ({ rect = null, zIndexClass = 'z-30' }) => {
  const isVisible =
    rect &&
    Number.isFinite(rect.x) &&
    Number.isFinite(rect.y) &&
    Number.isFinite(rect.w) &&
    Number.isFinite(rect.h) &&
    rect.w > 0 &&
    rect.h > 0;

  if (!isVisible) {
    return null;
  }

  return (
    <div
      data-testid='board-selection-overlay'
      className={`absolute border border-secondary bg-secondary bg-opacity-10 pointer-events-none ${zIndexClass}`}
      style={{
        left: rect.x,
        top: rect.y,
        width: rect.w,
        height: rect.h,
      }}
    />
  );
};
